import { render, staticRenderFns } from "./swpExcavation.vue?vue&type=template&id=2f4efaaa"
import script from "./swpExcavation.vue?vue&type=script&lang=js"
export * from "./swpExcavation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f4efaaa')) {
      api.createRecord('2f4efaaa', component.options)
    } else {
      api.reload('2f4efaaa', component.options)
    }
    module.hot.accept("./swpExcavation.vue?vue&type=template&id=2f4efaaa", function () {
      api.rerender('2f4efaaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/swpExcavation.vue"
export default component.exports